import {
  NOTIFICATION_GENERAL_CHANNEL,
  NotificationChannelsEnum,
  NotificationContentType,
  NotificationPriorityEnum,
  NotificationStateEnum,
  NotificationTypeEnum,
} from "../enums";
import { NonEmptyArray } from "../helpers/typings.helpers";
import { RydeUiUnit } from "./common.models";
import { SupportedLanguage } from "./i18n";

export interface INotificationContentLocalisedText {
  lang: SupportedLanguage;
  text: string;
  subject?: string;
}

export class NotificationContent {
  type: NotificationContentType;
  localisedTexts: NonEmptyArray<INotificationContentLocalisedText>;
}

export interface INotificationMetadata {
  supplierId?: number;
  tags?: string[];
  businessUnitId?: number;
}
export interface INotificationDto {
  id: number;
  companyId: number;
  alertId?: number;
  recipientId: number;
  recipientName: string;
  priority: NotificationPriorityEnum;
  entityId: number;
  entityName: RydeUiUnit;
  entityRecordId: number;
  title: string;
  type: NotificationTypeEnum;
  isRead: boolean;
  content: NonEmptyArray<NotificationContent>;
  metadata: INotificationMetadata;
  createdAt: TDateISO;
  updatedAt: TDateISO;
  state: NotificationStateEnum;
  siteId?: number;
  siteName?: string;
  unitId?: number;
  unitName?: string;
}

export interface ICountSummary {
  priority: NotificationPriorityEnum;
  count: number;
}

export interface IGetImportantResponseDto {
  notifications: INotificationDto[];
  countSummary: ICountSummary[];
}

export const TYPES_WITH_SUBJECT = [
  NOTIFICATION_GENERAL_CHANNEL,
  NotificationChannelsEnum.EMAIL,
];
